import React from "react";
import { VR_RE_IMAGES } from "../../../data/vrRealEstateImages";

const RealEstateHero = ({ onBrowseProperties, onHowItWorks }) => {
  const bg = VR_RE_IMAGES.heroWide;

  return (
    <section className="oshar-re-hero" aria-labelledby="oshar-re-hero-title">
      <div className="oshar-re-hero__media" aria-hidden>
        <img className="oshar-re-hero__img" src={bg} alt="" width={1920} height={1080} />
      </div>
      <div className="oshar-re-hero__veil" />
      <div className="oshar-re-hero__glow" aria-hidden />
      <div className="oshar-inner oshar-re-hero__inner">
        <p className="oshar-re-eyebrow">Oshar · Treydora VR City</p>
        <h1 id="oshar-re-hero-title" className="oshar-re-hero__title">
          OSHAR VR REAL ESTATE
        </h1>
        <p className="oshar-re-hero__sub">Own your place inside the living VR city of Treydora.</p>
        <p className="oshar-re-hero__body">
          Oshar is the city beyond the game — a VR world for commerce, guilds, events, storefronts,
          residences, and game-linked utility.
        </p>
        <div className="oshar-re-hero__actions">
          <button type="button" className="oshar-btn-gold oshar-re-btn-wide" onClick={onBrowseProperties}>
            Browse Properties
          </button>
          <button type="button" className="oshar-btn-outline oshar-re-btn-wide" onClick={onHowItWorks}>
            How It Works
          </button>
        </div>
        <ul className="oshar-re-badges" aria-label="Property highlights">
          <li className="oshar-re-badge">On-Chain NFT</li>
          <li className="oshar-re-badge">Game-Linked Utility</li>
          <li className="oshar-re-badge">Limited Genesis Supply</li>
          <li className="oshar-re-badge">Marketplace Access</li>
        </ul>
      </div>
    </section>
  );
};

export default RealEstateHero;
